"use client";

import { useEffect } from "react";
import { deepScrapeEmptyFields } from "@knowt/syncing/utils/dataCleaning";

declare global {
    interface Window {
        dataLayer: {
            event: string;
            [key: string]: string | number;
        }[];
    }
}

const GoogleTagManager = () => {
    useEffect(() => {
        const script = document.createElement("script");
        script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-K8VGVBR');`;

        document.head.appendChild(script);
    }, []);

    return null;
};

export const logGoogleTagManagerEvent = (event: string, data: Record<string, string | number | undefined>) => {
    window.dataLayer = window.dataLayer || [];

    const payload = {
        event,
        ...deepScrapeEmptyFields(data),
    };

    // biome-ignore lint/suspicious: noConsole
    console.log("Pushing to GTM:", payload);
    window.dataLayer.push(payload);
};

export default GoogleTagManager;
